import { IModuleInfo } from "./moduleInterface";
import { IModuleAction } from "./moduleReducer";

export function updateModule(modules: IModuleInfo[]): IModuleAction {
    return {
        type: "UPDATE_MODULE",
        payload: { modules: modules }
    }
};

export function setActiveModule(activeIndex: number): IModuleAction {
    return {
        type: "UPDATE_MODULE",
        payload: { activeIndex: activeIndex }
    }
}

export function setRunningIndex(runningIndex: number): IModuleAction {
    return {
        type: "UPDATE_MODULE",
        payload: { runningIndex: runningIndex }
    }
}